module.exports = __webpack_public_path__ + "static/media/frozen.b7778dd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/resell/frozen.png
// module id = 2111
// module chunks = 4